class FAQS247 extends HTMLElement {
  constructor() {
    super();
    this.headers = this.querySelectorAll('h4');
  }

  connectedCallback() {
    this.headers.forEach((header) => {
      // Add a chevron on the right that rotates
      header.innerHTML += `<svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 1L4 4L1 1" stroke="black"/></svg>`;

      // If there are multiple <svg> elements, remove all but the last one
      header.querySelectorAll('svg').forEach((svg) => {
        if (svg !== header.lastElementChild) {
          svg.remove();
        }
      });

      // Hide the <p> following each <h4> by default
      const nextElement = header.nextElementSibling;
      if (nextElement && nextElement.tagName === 'P') {
        nextElement.style.display = 'none';
      }

      // Add a click event listener to each <h4>
      header.addEventListener('click', () => {
        const currentP = header.nextElementSibling;

        if (currentP && currentP.tagName === 'P') {
          // Check if the <p> is visible
          const isVisible = currentP.style.display === 'block';

          this.headers.forEach((h) => {
            // Remove the active class from all <h4>
            h.classList.remove('active');

            // Close all <p> elements
            const p = h.nextElementSibling;
            if (p && p.tagName === 'P') {
              p.style.display = 'none';
            }
          });

          // Toggle the current <h4>
          header.classList.toggle('active', !isVisible);

          // Toggle the current <p>
          currentP.style.display = isVisible ? 'none' : 'block';
        }
      });
    });
  }
}

customElements.define('faqs-247', FAQS247);
